var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('Slider'),_c('Section1',{attrs:{"row":_vm.row}}),_c('Section2',{attrs:{"row":_vm.row}}),_c('Footer',{attrs:{"containerFluidHome":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }